import { createApi } from '@reduxjs/toolkit/query/react';
import camelize from 'camelize';
import {
  CustomerDetails,
  GetCustomerDetailsParams,
} from '../../dashboard/components/VendorCRM/VendorCustomerDetails/types';
import { baseQueryWithToast } from './base';

export const vendorCustomerDetailsApi = createApi({
  reducerPath: 'vendorCustomerDetails',
  baseQuery: baseQueryWithToast,
  tagTypes: ['CustomerDetails'],
  endpoints: (builder) => ({
    getCustomerDetails: builder.query<
      CustomerDetails,
      GetCustomerDetailsParams
    >({
      query: ({ vendorId, customerId }) => ({
        method: 'GET',
        url: `/api/vendor/${vendorId}/customers/${customerId}/details/`,
      }),
      providesTags: (_result, _error, { customerId }) => [
        { type: 'CustomerDetails', id: customerId },
      ],
      transformResponse: (response: unknown) =>
        camelize(response) as CustomerDetails,
    }),
  }),
});

export const { useGetCustomerDetailsQuery } = vendorCustomerDetailsApi;
